export default __webpack_public_path__ + "maps-guides-styles-expressions-zoom-high-960-1686b31a75634f7debefb9320c982ee7.webp";